var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button-list',{attrs:{"items":_vm.buttons,"value":_vm.value,"onclick":_vm.onclick}})}
var staticRenderFns = []

export { render, staticRenderFns }